import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _IsUserPremiumFromPartners } from "@discovery/common-dplus/lib/state";
import { AdunitPath, chName, ShowNameM, GenreM, IsMindBlownM, AdSizeDesktop, AdSizeMobile, } from "./optics";
import { useAds } from "../../utils/hooks/useAds";
import { _ShowAndVideoCollection } from "../optics";
const Banner = React.lazy(() => import("../../components/organisms/banner-ads"));
const getProps = (data) => {
    const adSizeDesktopM = Fold.preview(AdSizeDesktop, data);
    const adSizeDesktop = M.fromMaybe(adSizeDesktopM, "970x250,970x90,728x90");
    const adSizeMobileM = Fold.preview(AdSizeMobile, data);
    const adSizeMobile = M.fromMaybe(adSizeMobileM, "320x100, 320x50, 300x100, 300x50, 300x250");
    const bannerIdM = Fold.preview(AdunitPath, data);
    const bannerId = M.fromMaybe(bannerIdM, "");
    const channelNameM = Fold.preview(chName, data);
    const showNameM = Fold.preview(ShowNameM, data);
    const genreM = Fold.preview(GenreM, data);
    const isMindblownM = Fold.preview(IsMindBlownM, data);
    const targetingValues = Fold.toArray(_ShowAndVideoCollection, data);
    return {
        bannerId,
        isMindblownM,
        channelNameM,
        showNameM,
        genreM,
        targetingValues,
        adSizeDesktop,
        adSizeMobile,
    };
};
const BannerAds = ({ bannerId, isMindblownM, channelNameM, showNameM, genreM, targetingValues, adSizeDesktop, adSizeMobile, }) => {
    const { adsM, adsHasValidPackage, enableAds } = useAds();
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const adadUnitPathPrefixM = M.chain((x) => x.adUnitPathPrefix, adsM);
    const adUnitPathPrefix = M.fromMaybe(adadUnitPathPrefixM, "");
    const channelName = M.fromMaybe(channelNameM, "");
    const showName = M.fromMaybe(showNameM, "");
    const genre = M.fromMaybe(genreM, "");
    const isMindblown = M.fromMaybe(isMindblownM, "");
    const splitString = (value) => value.split(":");
    const channel = splitString(channelName);
    const show = splitString(showName);
    const genreName = splitString(genre);
    const isMindblownPage = splitString(isMindblown);
    const primaryChannel = targetingValues[0] && M.fromMaybe(targetingValues[0].primaryChannel, "");
    const channelNameE = channel.length > 1 && channel[1].includes("$%")
        ? primaryChannel
        : channel[1];
    const showNameE = show.length > 1 && show[1].includes("$%")
        ? targetingValues[0].name
        : show[1];
    const genreE = genreName.length > 1 && genreName[1].includes("$%")
        ? M.fromMaybe(targetingValues[0].genre, "")
        : genreName[1];
    const isMindblownE = isMindblownPage.length > 1 && isMindblownPage[1] === "true" ? true : false;
    const check = bannerId && !adsHasValidPackage;
    const isAdRendered = check ? "true" : "false";
    const isPremiumUser = enableAds && !adsHasValidPackage;
    const renderAds = isPremiumUser && !isPremiumUserFromPartner && bannerId;
    renderAds && localStorage.setItem("isAdRendered", isAdRendered);
    try {
        renderAds && localStorage.setItem("isAdRendered", isAdRendered);
    }
    catch (e) {
        console.info(e);
    }
    return renderAds ? (React.createElement(React.Suspense, { fallback: React.createElement("div", null, "Loading...") },
        React.createElement(Banner, { bannerId: bannerId, channelNameE: channelNameE, showNameE: showNameE, genreE: genreE, isMindblownE: isMindblownE, adUnitPathPrefix: adUnitPathPrefix, adSizeDesktop: adSizeDesktop, adSizeMobile: adSizeMobile }))) : (React.createElement(React.Fragment, null));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, BannerAds);

